<template>
  <header-section
    title="Boletas"
    :tabs="tabs"
  >
    <router-view />
  </header-section>
</template>

<script>
import BaseSection from "@/components/global/layout/BaseSection.vue";

export default {
  name: "evaluation-periods-tabs",
  extends: BaseSection,
  data: () => ({
    tabs: [
      {
        url: "/evaluation/reportcard-config",
        title: "Sets de periodos",
      },
      {
        url: "/evaluation/reportcard-config/visibility",
        title: "Visibilidad",
      },
      {
        url: "/evaluation/reportcard-config/attendance-list",
        title: "Asistencia",
      },
      {
        url: "/evaluation/reportcard-config/subjects",
        title: "Materias",
      },
    ],
  }),
};
</script>